export default __webpack_public_path__ + "static/media/tomamos tu usado.6c331a53.svg";